import React, { useEffect, useState } from 'react';
import { updateSelectedExtraOptions, deleteSelectedExtraOption, setBookingId, updateSearchData } from "../redux/data.js";
import { useDispatch, useSelector } from 'react-redux';
import { requestData } from '../js/api.js'

function Options() {
  const dispatch = useDispatch();
  const [coverageOptions, setCoverageOptions] = useState([])
  const [optionalExtras, setOptionalExtras] = useState([])
  const [kilometresOptions, setKilometresOptions] = useState([])
  const selectedExtraOptions = useSelector((state) => state.data.selectedExtraOptions);
  const [selectedCoverage, setSelectedCoverage] = useState('');
  const [selectedKilometres, setSelectedKilometres] = useState('');
  const vehicleDetails = useSelector((state) => state.data.searchData.vehicleDetails);
  const handleChange = (event) => {
    setSelectedCoverage(event.target.value);
    dispatch(updateSearchData({ key: 'damageLiability', value: event.target.value }))
  };
  const handleChangeKilometres = (event) => {
    setSelectedKilometres(event.target.value);
    dispatch(updateSearchData({ key: 'included_kilometres', value: event.target.value }))
  };
  const AddExtraOption = (item) => {
    dispatch(updateSelectedExtraOptions({ key: item.code }))
  }
  const MinusExtraOption = (item) => {
    dispatch(deleteSelectedExtraOption({ key: item.code }))
  }
  const handleBack = () => {
    dispatch(setBookingId('select-vehicle'))
  }

  const handleNext = () => {
    dispatch(setBookingId('book'))
  }

  const getOptions = async (id) => {
    try {
      const data = await requestData('GET', 'options/' + id);
      setCoverageOptions(data.insurance)
      setOptionalExtras(data.options)
      setKilometresOptions(data.included_kilometres)
    } catch (error) {
      console.error('Error:', error.message);
    }
  };
  

  useEffect(() => {
    getOptions(vehicleDetails.vehicle_id)
  }, [vehicleDetails])

  useEffect(()=>{
    setSelectedCoverage(coverageOptions[0]?.code)
    dispatch(updateSearchData({ key: 'damageLiability', value: coverageOptions[0]?.code }))
    setSelectedKilometres(kilometresOptions[0]?.code)
    dispatch(updateSearchData({ key: 'included_kilometres', value: kilometresOptions[0]?.code }))
  },[coverageOptions,kilometresOptions])    // eslint-disable-line
  return (
    <div>
      <div className="w-full p-4 border-b-2 border-gray-200">
        <div className='text-left my-2'>
          <div className="text-xl text-gray-800 font-bold">Coverage</div>
          {/* <div>The daily rental rate of your vehicle selected includes cover for damage including third party or theft with an excess of $4,400.00. This damage excess can be reduced by selecting one of our loss damage covers below.</div> */}
        </div>
        <ul className="mt-6 space-y-3">
          {
            coverageOptions.map((item, idx) => (
              <li key={item.code}>
                <label htmlFor={item.code} className="block relative">
                  <input id={item.code} type="radio" value={item.code}
                    checked={selectedCoverage === item.code}
                    onChange={handleChange}
                    name="insurance" class="sr-only peer" />
                  <div className="w-full p-5 cursor-pointer rounded-lg border bg-white/60 shadow-sm ring-primary peer-checked:ring-2 duration-200 relative">
                    <div className="pl-7">
                      <h3 className="font-bold text-l leading-none text-gray-800">
                        {item.title}
                      </h3>
                      <p className="mt-1 text-sm text-gray-600">
                        {item.description}
                      </p>
                      {/* <p className="mt-3 text-sm text-gray-900">
                        {item.description}
                      </p> */}
                    </div>
                    <div className="xl:absolute relative right-4 top-2 text-primary ">
                      <span className=''>AUD </span>
                      <span className='font-bold text-3xl text-primary italic'>{item.price}</span>
                      <span className='text-right'>{item.unit==='per_day'?'/day':''}</span>
                    </div>

                  </div>
                  <span className="block absolute top-5 left-5 border peer-checked:border-[5px] peer-checked:border-primary w-4 h-4 rounded-full">
                  </span>
                </label>
              </li>
            ))
          }
        </ul>
      </div>
      <div className="w-full p-4 border-b-2 border-gray-200">
        <div className='text-left my-2'>
          <div className="text-xl text-gray-800 font-bold">Optional Extras</div>
          {
            optionalExtras.map((item, idx) => (
              <li key={item.code} className="py-5 flex items-start justify-between">
                <div className="flex gap-3 w-[70%]">
                  {/* <img src={item.avatar} className="flex-none w-12 h-12 rounded-full" /> */}
                  <div>
                    <span className="block text-sm text-gray-700 font-semibold">{item.title}</span>
                    <span className="block text-sm text-gray-600">{item.description}</span>
                  </div>
                </div>
                <div className='w-[10rem] text-primary text-center'>
                  <div>
                    <span className=''>AUD </span>
                    <span className='font-bold text-3xl text-primary italic'>{item.price}</span>
                    <span className='text-right'>{item.unit==='per_day'?'/day':''}</span>
                  </div>

                  {item.code in selectedExtraOptions ? (
                    item?.unit === 'per_day' ? (
                      <button
                        className="mt-2 bg-primary hover:bg-primary/80 text-white font-semibold px-5 py-2 rounded-lg"
                        onClick={() => MinusExtraOption(item)}
                      >
                        Delete
                      </button>
                    ) : (
                      <div>
                        <button
                          className="mt-2 bg-primary hover:bg-primary/80 text-white font-semibold p-2 rounded-lg"
                          onClick={() => MinusExtraOption(item)}
                        >
                          -
                        </button>
                        &nbsp;{selectedExtraOptions[item.code]}&nbsp;
                        <button
                          className="mt-2 bg-primary hover:bg-primary/80 text-white font-semibold p-2 rounded-lg"
                          onClick={() => AddExtraOption(item)}
                        >
                          +
                        </button>
                      </div>
                    )
                  ) : (
                    <button
                      className="mt-2 bg-primary hover:bg-primary/80 text-white font-semibold px-5 py-2 rounded-lg"
                      onClick={() => AddExtraOption(item)}
                    >
                      Add
                    </button>
                  )}

                </div>
              </li>
            ))
          }
        </div>
      </div>
      <div className="w-full p-4">
        <div className='text-left my-2'>
          <div className="text-xl text-gray-800 font-bold">Included Kilometres</div>
        </div>
        <ul className="my-6 space-y-3">
          {
            kilometresOptions.map((item, idx) => (
              <li key={item.code}>
                <label htmlFor={item.code} className="block relative">
                  <input id={item.code} value={item.code} type="radio" checked={selectedKilometres === item.code}
                    onChange={handleChangeKilometres} name="kilo" class="sr-only peer" />
                  <div className="w-full p-5 cursor-pointer rounded-lg border bg-white/60 shadow-sm ring-primary peer-checked:ring-2 duration-200 relative">
                    <div className="pl-7">
                      <h3 className="font-bold text-l leading-none text-gray-800">
                        {item.title}
                      </h3>
                      <p className="mt-1 text-sm text-gray-600">
                        {item.description}
                      </p>
                    </div>
                    <div className="md:absolute relative right-4 top-2 text-primary ">
                      <span className=''>AUD </span>
                      <span className='font-bold text-3xl text-primary italic'>{item.price}</span>
                      <span className='text-right'>/day</span>
                    </div>

                  </div>
                  <span className="block absolute top-5 left-5 border peer-checked:border-[5px] peer-checked:border-primary w-4 h-4 rounded-full">
                  </span>
                </label>
              </li>
            ))
          }
        </ul>
      </div>
      <div className='mx-4 flex justify-between'>
        <button
          onClick={handleBack}
        >
          &larr;&nbsp;Previous
        </button>
        <button
          onClick={handleNext}
          className='text-primary'
        >
          Next&nbsp;&rarr;
        </button>
      </div>
    </div>
  )
}

export default Options;